import { createRouter, createWebHistory } from 'vue-router'
import Home from '../views/HomePage.vue'
import Destination from '../views/DestinationSingle.vue'
import Destinations from '../views/DestinationsMulti.vue'
import BlogList from '../views/BlogList.vue'
import BlogPost from '../views/BlogPost.vue'

// Create route groups for both languages
const createRoutes = (prefix = '') => [
  {
    path: `${prefix}/`,
    name: `${prefix}homepage`.replace('/', ''),
    component: Home,
  },
  {
    path: `${prefix}/destinations`,
    name: `${prefix}destinationsmulti`.replace('/', ''),
    component: Destinations,
    meta: {
      title: prefix.includes('el') 
        ? 'Ακτοπλοϊκά Εισιτήρια για Ελληνικά Νησιά | Κράτηση Online'
        : 'Ferry Destinations | Book Greek Island Ferry Tickets',
    },
  },
  {
    path: `${prefix}/destination/:id`,
    name: `${prefix}destination`.replace('/', ''),
    component: Destination,
    meta: {
      title: (route) => {
        const name = route.params.id.charAt(0).toUpperCase() + route.params.id.slice(1)
        return prefix.includes('el')
          ? `${name} Ακτοπλοϊκά Εισιτήρια | Online Κράτηση`
          : `${name} Ferry Tickets | Book Online`
      },
    },
  },
  {
    path: `${prefix}/blog`,
    name: `${prefix}blog`.replace('/', ''),
    component: BlogList,
    meta: {
      title: prefix.includes('el')
        ? 'Travel Blog | Ταξιδιωτικές Ιστορίες και Συμβουλές'
        : 'Travel Blog | Greek Island Travel Stories and Tips',
    },
  },
  {
    path: `${prefix}/blog/:id`,
    name: `${prefix}blog-post`.replace('/', ''),
    component: BlogPost,
    meta: {
      title: (route) => {
        const post = router.app?.$root?.$data?.currentPost
        return post 
          ? `${post.title} | ${prefix.includes('el') ? 'Travel Blog' : 'Travel Blog'}`
          : prefix.includes('el') ? 'Blog Post' : 'Blog Post'
      },
    },
  },
  {
    path: `${prefix}/privacy-policy`,
    name: `${prefix}privacy-policy`.replace('/', ''),
    component: () => import('../views/PrivacyPolicy.vue'),
    meta: {
      title: prefix.includes('el')
        ? 'Πολιτική Απορρήτου | Aktoploika'
        : 'Privacy Policy | Aktoploika',
    },
  },
]

const router = createRouter({
  history: createWebHistory('/'),
  routes: [
    // Greek routes (with /el prefix)
    {
      path: '/el',
      name: 'elhomepage',
      component: Home,
      meta: {
        title: 'Ακτοπλοϊκά Εισιτήρια | Κράτηση Online'
      }
    },
    ...createRoutes('/el'),
    // English routes (default, no prefix)
    ...createRoutes(),
    // Catch-all redirect to home
    {
      path: '/:pathMatch(.*)*',
      redirect: '/'
    }
  ],
  scrollBehavior(to, from, savedPosition) {
    if (savedPosition) {
      return savedPosition
    }
    return { top: 0 }
  },
})

// Update document title based on route meta
router.beforeEach((to, from, next) => {
  const title = typeof to.meta.title === 'function' ? to.meta.title(to) : to.meta.title
  document.title = title || 'Aktoploika - Greek Island Ferry Tickets'
  next()
})

export default router
